var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 126,
    viewBox: "0 0 124 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_643_698",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 23,
    width: 68,
    height: 81
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4372 23.3566C43.4372 23.3566 84.4939 104.404 85.5409 103.027C86.5879 101.65 110.919 61.5833 110.919 61.5833L43.4372 23.3566Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0322792
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_643_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8594 90.43L62.7544 82.8031L60.5475 81.5172L58.6781 80.9478L57.1445 81.149L55.246 81.8155L53.6248 82.4476L51.5613 83.2499L49.9383 83.8847L48.1112 84.2756L45.4443 85.2516L42.954 84.095L42.6675 79.4594L44.6289 61.1681L47.8328 33.8167L51.0337 32.3772L56.2877 36.0046L77.3806 47.912L91.245 55.9068L91.983 60.141L82.4955 83.491L77.8594 90.43Z",
    fill: "#03B853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6875 88.4845L49.5879 32.6578L90.5844 54.8434L93.0159 58.3408L80.3839 88.5066L79.8396 89.8861L78.2843 89.4186L78.6875 88.4845Z",
    fill: "#03B853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2168 32.7886L88.1018 52.9312C91.8396 54.9095 93.4017 57.0776 92.1813 59.6545L80.8818 87.4713C79.7464 90.2179 77.8535 91.2608 74.8688 89.8619L60.547 81.5196C59.1246 80.5495 57.3755 80.9823 55.8817 81.5677L47.3034 84.9134C44.1862 85.9906 42.8629 84.4351 42.4438 81.5583L47.3076 36.2147C47.5782 32.7522 49.089 31.4019 52.2168 32.7886Z",
    stroke: "black",
    strokeWidth: 1.86357,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6107 89.3431L49.2197 33.1924",
    stroke: "black",
    strokeWidth: 1.86357,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_643_698",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 22,
    width: 49,
    height: 81
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5285 22.9083C44.5285 22.9083 87.6593 102.871 85.9309 102.945C84.2026 103.019 37.4153 100.139 37.4153 100.139L44.5285 22.9083Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0322792
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_643_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9703 89.4497L82.3259 72.6931L82.5292 70.1471L83.1283 68.287L84.1686 67.1423L85.7993 65.9635L87.2435 64.9929L89.0797 63.7561L90.5271 62.7854L91.8907 61.508L94.214 59.8748L94.6852 57.1698L91.0418 54.2894L74.9013 45.463L50.6116 32.4872L47.603 34.2945L47.5839 40.679L45.3268 64.7954L43.9812 80.7431L47.0372 83.7652L71.6264 89.2975L79.9703 89.4497Z",
    fill: "#036D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8993 89.0204L48.6576 33.268L43.484 79.5946L44.9688 83.587L76.9495 90.4262L78.393 90.7664L78.8965 89.2223L77.8993 89.0204Z",
    fill: "#036D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.266 35.5003L43.3313 76.4633C42.8231 80.6617 43.7123 83.1817 46.5249 83.6499L75.8162 90.243C78.7197 90.8778 80.6562 89.9184 81.2105 86.6691L82.5317 70.1474C82.5467 68.4258 83.9002 67.2364 85.2333 66.3437L92.8756 61.2081C95.539 59.2628 95.0167 57.2885 92.8933 55.3029L52.8808 33.4237C49.8829 31.6702 47.912 32.1403 47.266 35.5003Z",
    stroke: "black",
    strokeWidth: 1.86357,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6481 89.4461L49.3066 33.2695",
    stroke: "black",
    strokeWidth: 1.86357,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLogo);
export default __webpack_public_path__ + "static/media/about-logo.63d9cc3553a4a4f87c64bf82d2808a8b.svg";
export { ForwardRef as ReactComponent };